import Button from "@mui/material/Button";
import KeyboardBackspaceIcon from "@mui/icons-material/KeyboardBackspace";
import { useTranslation } from "react-i18next";

const BackButton = (props) => {
  const { t } = useTranslation();
  return (
    <Button
      variant="outlined"
      startIcon={<KeyboardBackspaceIcon />}
      color="cancel"
      onClick={props.onClick}
    >
      {t("Back")}
    </Button>
  );
};

export default BackButton
